<template>
  <header>
    <label for="toggle-1" class="toggle-menu" @click="toggleMenu">
      <ul>
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </label>
    <!-- <strong @click="toggleMenu"> &#9776;	</strong> -->
    <nav class="nav_center" style="padding: 0" :style="{ display: isMenuVisible ? 'block' : 'none' }">
      <ul style="list-style: none">
        
        <li style="border-right: 1px solid #e0cbcb94">
          <a class="f-s--title" id="banHangQRdong" href="/taichinhtoandien">{{
            currentLanguage.item_footer_0
          }}</a>
        </li>
        <li style="border-right: 1px solid #e0cbcb94">
          <a class="f-s--title" id="Gd_Yte" href="/giaoduc">{{ currentLanguage.item_footer_4 }}
          </a>
        </li>

        <li style="border-right: 1px solid #e0cbcb94">
          <a class="f-s--title" id="dichVuThuChiHo" href="/giaothongthongminh">{{ currentLanguage.item_footer_3
          }}</a>
        </li>

        <li style="border-right: 1px solid #e0cbcb94">
          <a class="f-s--title" id="giaiPhapChuyenDoiSo" href="/y-te">{{ currentLanguage.item_footer_1
          }}</a>
        </li>
        <li style="border-right: 1px solid #e0cbcb94">
          <a class="f-s--title" id="thesinhtrachoc" href="/dichvucong-nongnghiepthongminh">{{
            currentLanguage.item_footer_2 }}</a>
        </li>
<li style="border-right: 1px solid #e0cbcb94">
          <a class="f-s--title" id="Gt_Dvc" href="/chuongtrinhtaitroxathidiem">{{ currentLanguage.item_footer_5 }}
          </a>
        </li>
        <li style="border-right: 1px solid #e0cbcb94">
          <a class="f-s--title" id="thietBiVaDichVu" href="/thietbivadichvu">{{ currentLanguage.item_footer_6 }}
          </a>
        </li>

        <li>
          <a class="f-s--title" id="congTy" href="/congty">{{
            currentLanguage.item_footer_7
          }}</a>
        </li>
      </ul>
    </nav>
    <div class="menu_right" style="display: flex">
      <a @click="changeLanguage('vi')" class="lang" style="padding: 5px"><img
          src="img/img-item-vimass-2022/co/vi-VN.gif" />
      </a>
      <a @click="changeLanguage('en')" class="lang" style="padding: 5px"><img style="width: 25px"
          src="img/img-item-vimass-2022/co/us.png" />
      </a>
      <a @click="changeLanguage('cn')" class="lang d-none" style="padding: 5px"><img style="width: 25px"
          src="img/img-item-vimass-2022/co/cn.jpg" />
      </a>
      <a @click="changeLanguage('kr')" class="lang d-none" style="padding: 5px"><img style="width: 25px"
          src="img/img-item-vimass-2022/co/kr.jpg" />
      </a>

      <span class="clickShow" style="color: #ffffff; cursor: pointer; margin: auto; padding: 5px"><i
          class="fa fa-ellipsis-h" aria-hidden="true"></i></span>
      <div class="showCo" style="display: none; margin: auto">
        <a onclick="changeLang('us')" class="lang"><img src="img/img-item-vimass-2022/co/indo.jpg" />
        </a>
        <a onclick="changeLang('us')" class="lang"><img src="img/img-item-vimass-2022/co/tl.png" />
        </a>
        <a onclick="changeLang('us')" class="lang"><img src="img/img-item-vimass-2022/co/thailan.png" />
        </a>
        <a onclick="changeLang('us')" class="lang"><img src="img/img-item-vimass-2022/co/hu.jpg" />
        </a>
      </div>
      <a id="urlHome" href="/" style="margin: 0 10px"><img style="width: 35px; height: 35px"
          src="img/home-icon-white-8.jpg" />
      </a>
    </div>
  </header>
  <div class="wrapper row3">
    <main class="hoc container-fluid clear bv">
      <div style="min-height: 500px" class="padding-top15">
        <div class="title-bai-viet" v-html="titleHeThong"></div>
        <div v-html="contentHeThong"></div>
      </div>
    </main>
  </div>

  <!-- tooltip  -->
  <!-- <div class="tooltip-container" data-tooltip-id="tooltip1"><span class="tooltip-trigger">can hien thi gi thi viet vao day</span>

<div class="tooltip-box">
  <input checked="checked" id="tab1" name="tab-group1" type="radio" /> 
  <label for="tab1">Lịch sử</label> 
  <input id="tab2" name="tab-group1" type="radio" /> 
  <label for="tab2">Gương mặt</label> 
  <input id="tab3" name="tab-group1" type="radio" /> 
  <label for="tab3">Tham khảo</label>

<div class="tab-content" id="content1"><span>Trường được th&agrave;nh lập năm 1965...</span></div>

<div class="tab-content" id="content2"><span>Ng&ocirc; Qu&yacute; Đăng đạt điểm tuyệt đối IMO...</span></div>

<div class="tab-content" id="content3">
<ul>
	<li><a href="https://vnexpress.net" target="_blank">VnExpress</a></li>
</ul>
</div>
</div>
</div> -->

  <!-- end tooltip -->
<floatingB @click="scrollToTop"></floatingB>
  <FooterView></FooterView>
</template>

<script>
import { languages } from "@/components/languages";
import axios from "axios";
import { apiChiTietBaiViet } from "@/components/listService";
import FooterView from "@/views/Vimass/Footer/FooterView.vue";
import floatingB from "@/views/Vimass/Home/FloattingButtonVimass.vue";
// import { watch, nextTick } from 'vue'
export default {
  components: {
    FooterView,floatingB
  },
  data() {
    return {
      currentLanguage: languages.vi,
      isMenuVisible: false,

      lang: "",
      base64: "",
      base64Title: "",
      //title
      titleHeThong: "",
      //content
      contentHeThong: "",
      hasMounted: false,
      idBaiViet: "",

    };
  },

  mounted() {
    if (window.innerWidth <= 768) {
      this.isMenuVisible = false;
    } else {
      this.isMenuVisible = true;
    }

    let url = window.location.href;
    let pathArray = url.split("/");
    let lang1 = pathArray[pathArray.length - 3];
    localStorage.setItem("languages", lang1);
    const lang = localStorage.getItem("languages") || "vi";

    this.lang = lang;
    if (this.lang == "vi") {
      document.title = "Vimass.vn - Tin tức";
    } else if (this.lang == "en") {
      document.title = "Vimass.vn - News";
    } else if (this.lang == "cn") {
      document.title = "Vimass.vn - 帖子";
    } else if (this.lang == "kr") {
      document.title = "Vimass.vn - 게시물";
    } else {
      document.title = "Vimass.vn - Tin tức";
    }
    if (!this.hasMounted) {
      this.hasMounted = true;
      this.idBaiViet = this.$route.params.id;
      if (this.lang) {
        // Kiểm tra giá trị của this.lang trước khi sử dụng
        this.$router.push({
          path: "/" + this.lang + "/chi-tiet.html/" + this.idBaiViet,
        });
      }
    }

    document.getElementById("urlHome").setAttribute("href", this.lang);
    // document.getElementById("qrAmThanh").setAttribute("href", lang + "/qramthanh");

    document
      .getElementById("banHangQRdong")
      .setAttribute("href", lang + "/taichinhtoandien");

    document
      .getElementById("dichVuThuChiHo")
      .setAttribute("href", lang + "/giaothongthongminh");

    document
      .getElementById("giaiPhapChuyenDoiSo")
      .setAttribute("href", lang + "/y-te");

    document.getElementById("Gd_Yte").setAttribute("href", lang + "/giaoduc");
    document
      .getElementById("Gt_Dvc")
      .setAttribute("href", lang + "/chuongtrinhtaitroxathidiem");
    document
      .getElementById("thesinhtrachoc")
      .setAttribute("href", lang + "/dichvucong-nongnghiepthongminh");

    document
      .getElementById("thietBiVaDichVu")
      .setAttribute("href", lang + "/thietbivadichvu");
    document.getElementById("congTy").setAttribute("href", lang + "/congty");

    if (this.$refs.manHinhChinh) {
      const imgElement = this.$refs.manHinhChinh;
      imgElement.addEventListener("click", this.handleClick);
      // console.log("Ref tồn tại");
    } else {
      // console.log("Ref không tồn tại");
    }
    if (this.lang && languages[this.lang]) {
      this.currentLanguage = languages[this.lang];
    }

    this.performPostRequest(this.idBaiViet);

    this.initTooltipListeners()

    this.$watch(
      () => this.contentHeThong,
      async () => {
        await this.$nextTick()
        console.log('✅ htmlContent đã thay đổi & render xong')
        this.initTooltipListeners()
      }
    )
  },

  methods: {
     scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  },
    handleClick() {
      // Xử lý sự kiện click ở đây
      console.log("Đã click vào màn hình chính");
    },

    toggleMenu() {
            this.isMenuVisible = !this.isMenuVisible;
    },
    changeLanguage(lang) {
      // this.currentLanguage = languages[lang];
      // localStorage.setItem("languages", lang);
      // window.location.reload();
      // const currentPath = this.$route.fullPath;
      const idBaiViet = this.idBaiViet; // Đảm bảo biến idBaiViet đã được định nghĩa ở nơi khác

      // Cập nhật URL mới với ngôn ngữ và id bài viết
      const newPath = "/" + lang + "/chi-tiet.html/" + idBaiViet;

      // Reload trang với URL mới
      window.location.href = newPath;
    },

    async performPostRequest(id) {
      this.lang = localStorage.getItem("languages") || "vi";

      try {
        // Thực hiện POST request
        const response = await axios.post(apiChiTietBaiViet, {
          id: id,
          langId: "0",
        });

        if (this.lang === "vi") {
          this.base64 = response.data.result.content_vi;
          this.base64Title = response.data.result.title_vi;
        } else if (this.lang === "en") {
          this.base64 = response.data.result.content_en;
          this.base64Title = response.data.result.title_en;
        } else if (this.lang === "cn") {
          this.base64 = response.data.result.content_cn;
          this.base64Title = response.data.result.title_cn;
        } else if (this.lang === "kr") {
          this.base64 = response.data.result.content_kr;
          this.base64Title = response.data.result.title_kr;
        } else {
          this.base64 = response.data.result.content_vi;
          this.base64Title = response.data.result.title_vi;
        }
        var title = atob(this.base64Title);
        var decodedString = atob(this.base64);

        this.titleHeThong = decodeURIComponent(escape(title));
        this.contentHeThong = decodeURIComponent(escape(decodedString));
      } catch (error) {
        console.error("Error:", error);
      }
    },

    initTooltipListeners() {
      console.log('📦 initTooltipListeners gọi...')
      document.querySelectorAll('.tooltip-trigger').forEach(trigger => {
        console.log('🔁 Found tooltip trigger:', trigger)
        const container = trigger.closest('.tooltip-container')
        const tooltip = container?.querySelector('.tooltip-box')

        if (!tooltip || trigger.dataset.tooltipInit) return

        // Gắn sự kiện click toggle tooltip
        trigger.addEventListener('click', (e) => {
          e.stopPropagation()
          console.log('🔍 Trigger tooltip clicked')
          // Ẩn tất cả tooltip khác
          document.querySelectorAll('.tooltip-box').forEach(el => el.style.visibility = 'hidden')
          // Toggle tooltip hiện tại
          tooltip.style.visibility = (tooltip.style.visibility === 'visible') ? 'hidden' : 'visible'
        })

        // Đánh dấu đã gắn sự kiện để tránh gắn nhiều lần
        trigger.dataset.tooltipInit = 'true'
      })

      // Click bên ngoài để ẩn tất cả
      document.addEventListener('click', (event) => {
        // Nếu click KHÔNG nằm trong bất kỳ .tooltip-container nào
        if (!event.target.closest('.tooltip-container')) {
          document.querySelectorAll('.tooltip-box').forEach(el => {
            el.style.visibility = 'hidden'
          })
        }
      })

    }
  },

};
</script>
<style scoped>
.f-s--title {
  font-size: 14px;
}
</style>